import axios from 'axios'
import $global from '@xt/client/store/global'
import { clientInfoInterceptors, pathUrlInterceptors, authInterceptors, headerInterceptors } from './interceptors/request'
import { apiReportResponseInterceptors, syncTimeResponseInterceptors, dataResponseInterceptors } from './interceptors/response'

export const proxyTarget = {
  api: '/devTarget',
  static: '/devStaticTarget'
}

const requestTimeout = 15 * 1000

const axiosInstance = axios.create({
  baseURL: $global.dev ? proxyTarget.api : $global.target,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: requestTimeout,
  transitional: {
    clarifyTimeoutError: true
  }
})

axiosInstance.interceptors.request.use(clientInfoInterceptors.success, null, {
  // static域名下不需要加client-info
  runWhen: config => {
    return config.baseURL!.indexOf($global.static!) === -1
  }
})
axiosInstance.interceptors.request.use(pathUrlInterceptors.success, null)
axiosInstance.interceptors.request.use(authInterceptors.success, null, {
  // static域名下不需要加Authorization
  runWhen: config => {
    return config.baseURL!.indexOf($global.static!) === -1
  }
})
axiosInstance.interceptors.request.use(headerInterceptors.success, null)

axiosInstance.interceptors.response.use(apiReportResponseInterceptors.success, apiReportResponseInterceptors.fail)
axiosInstance.interceptors.response.use(syncTimeResponseInterceptors.success, syncTimeResponseInterceptors.fail)
axiosInstance.interceptors.response.use(dataResponseInterceptors.success, dataResponseInterceptors.fail)

export default axiosInstance
